import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import {
  fetchSurveyRoutine,
  fetchAttributesRoutine,
  fetchDefaultQuestionsRoutine,
  saveSurveyRoutine,
  checkSurveyNameRoutine,
  fetchQuestionsRoutine
} from '../../routines';
import {
  getSurveyById,
  getDefaultQuestions,
  checkSurveyName,
  updateSurvey,
  createSurvey
} from '../../../../services/surveyService';
import { getAttributes } from '../../../../services/attributeService';
import { getQuestions } from '../../../../services/questionService';
import { successToast, errorToast } from '../../../../common/helpers/toastrHelper';
import { QuestionSection } from '../../../../common/enums/QuestionSection';

function* getSurvey({ payload }: Routine<any>) {
  try {
    yield put(fetchSurveyRoutine.request());
    const response = yield call(getSurveyById, payload);

    yield put(fetchSurveyRoutine.success(response));
  } catch (error) {
    yield put(fetchSurveyRoutine.failure(error.message));
  }
}

function* watchGetSurveyReq() {
  yield takeEvery(fetchSurveyRoutine.TRIGGER, getSurvey);
}

function* getAttributesReq() {
  try {
    const response = yield call(getAttributes);

    yield put(fetchAttributesRoutine.success(response));
  } catch (error) {
    yield put(fetchAttributesRoutine.failure(error.message));
  }
}

function* watchGetAttributesReq() {
  yield takeEvery(fetchAttributesRoutine.TRIGGER, getAttributesReq);
}

function* getDefaultQuestionsReq() {
  try {
    yield put(fetchDefaultQuestionsRoutine.request());
    const data = yield call(getDefaultQuestions);
    yield put(fetchDefaultQuestionsRoutine.success(data));
  } catch (error) {
    yield put(fetchDefaultQuestionsRoutine.failure(error.message));
  }
}

function* watchGetDefaultQuestionsReq() {
  yield takeEvery(fetchDefaultQuestionsRoutine.TRIGGER, getDefaultQuestionsReq);
}

function* getQuestionsReq({ payload }: Routine<any>) {
  try {
    const data = yield call(getQuestions, payload === QuestionSection.SoftSkills);
    yield put(fetchQuestionsRoutine.success({ data, type: payload }));
  } catch (error) {
    yield put(fetchQuestionsRoutine.failure(error.message));
  }
}

function* watchGetQuestionsReq() {
  yield takeEvery(fetchQuestionsRoutine.TRIGGER, getQuestionsReq);
}

function* saveSurveyReq({ payload }: Routine<any>) {
  try {
    const data = yield call(payload.id ? updateSurvey : createSurvey, payload);
    yield put(saveSurveyRoutine.success(data));
    yield call(successToast, 'Survey successfully saved!', 'toast.surveySavedSuccess');
  } catch (error) {
    yield put(saveSurveyRoutine.failure(error.message));
    yield call(errorToast, error.message);
  } finally {
    yield put(saveSurveyRoutine.fulfill());
  }
}

function* watchSaveSurveyNameReq() {
  yield takeEvery(saveSurveyRoutine.TRIGGER, saveSurveyReq);
}

function* checkSurveyNameReq({ payload }: Routine<any>) {
  try {
    const { isNameTaken } = yield call(checkSurveyName, { name: payload.name, id: payload.id });
    yield put(checkSurveyNameRoutine.success({ isNameTaken, isSaveAs: payload.isSaveAs }));
  } catch (error) {
    yield put(checkSurveyNameRoutine.failure(error.message));
  }
}

function* watchCheckSurveyNameReq() {
  yield takeEvery(checkSurveyNameRoutine.TRIGGER, checkSurveyNameReq);
}

export default function* surveySaga() {
  yield all([
    watchGetSurveyReq(),
    watchGetAttributesReq(),
    watchGetDefaultQuestionsReq(),
    watchCheckSurveyNameReq(),
    watchSaveSurveyNameReq(),
    watchGetQuestionsReq()
  ]);
}
